module.exports = __webpack_public_path__ + "img/download.ebb2ceed.webp";